export default "__VITE_ASSET__DcD$Fkqv__"